import {Directive, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NgModel} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';

@Directive({    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[cmnDebounce][formControlName],[cmnDebounce][formControl],[cmnDebounce][ngModel]'
})
export class CmnDebounceDirective implements OnInit, OnChanges {
    @Input() cmnDebounce: number;
    valueChanges = new Subject<string>();
    subscription: Subscription;

    constructor(public model: NgModel) {
    }

    ngOnInit(): void {
        (this.model.options = this.model.options || {}).updateOn = 'blur';
        this.model['_setUpdateStrategy']();   // Note this does use private function that might change.

        this.updateDebounce();

        this.model.valueAccessor.registerOnChange((event) => this.valueChanges.next(event));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['cmnDebounce']) {
            this.updateDebounce();
        }
    }

    updateDebounce() {
        this.unsubscribe();
        this.cmnDebounce = this.cmnDebounce || 500;
        this.subscription = this.valueChanges.pipe(debounceTime(this.cmnDebounce)).subscribe($event => this.emitChange($event));
    }

    unsubscribe() {
        this.subscription?.unsubscribe();
    }

    emitChange(value) {
        this.model.control.patchValue(value, {emitEvent: true});
    }
}
